// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createAction } from '@reduxjs/toolkit';
import type * as GeoJSON from 'geojson';

// eslint-disable-next-line import/prefer-default-export
export const LoadPanoFeaturesSuccessAction = createAction<GeoJSON.Feature<GeoJSON.Point>[]>(
  'pano/LoadPanoFeaturesSuccessAction',
);
// Action to clear all pano features
export const ClearPanoFeaturesAction = createAction('pano/ClearPanoFeaturesAction');

export const GetAllAnnotationSuccessAction = createAction('annotation/GetAllAnnotationSuccessAction');

// Clear Annotation
export const ClearAnnotationSuccessAction = createAction('annotation/ClearAnnotationSuccessAction');

// Create Annotation
export const CreateAnnotationSuccessAction = createAction('annotation/CreateAnnotationSuccessAction');

// Edit Annotation
export const EditAnnotationSuccessAction = createAction('annotation/EditAnnotationSuccessAction');

// Delete Annotation
export const DeleteAnnotationSuccessAction = createAction('annotation/DeleteAnnotationSuccessAction');
